export const setShowSuccessMessage = (show) => ({
  type: "SET_SHOW_SUCCESS_MESSAGE",
  payload: show,
});

export const setShowDeletePrompt = (show) => ({
  type: "SET_SHOW_DELETE_PROMPT",
  payload: show,
});

export const setDeleteModalOpen = (show) => ({
  type: "SET_DELETE_MODAL_OPEN",
  payload: show,
});

export const setEmployeesToDelete = (show) => ({
  type: "SET_EMPLOYEES_TO_DELETE",
  payload: show,
});

export const setDeleteEmployeesModalOpen = (show) => ({
  type: "SET_DELETE_EMPLOYEES_MODAL_OPEN",
  payload: show,
});
export const setShowDeleteSuccessMessage = (show) => ({
  type: "SET_SHOW_DELETE_SUCCESS_MESSAGE",
  payload: show,
});

export const setChildPositions = (show) => ({
  type: "SET_CHILD_POSITIONS",
  payload: show,
});
export const setParentID = (id) => ({
  type: "SET_PARENT_ID",
  payload: id,
});

